import React, { useEffect, useState } from 'react';
import { Button } from '../../components/Button';
import workflowApi from '../../api/workflowApi';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { X } from 'lucide-react';

export const CreateWorkflowModal = ({ setShowCreateWorkflow, workflowTemplates,onSuccess, clients,accountId }) => {
    const token = useSelector((state) => state.auth.access_token);
    const userId = useSelector((state) => state.auth.userdetails.id);

    const [workflowName, setWorkflowName] = useState('');
    const [description, setDescription] = useState('');
    const [category, setCategory] = useState('');
    const [status, setStatus] = useState('');
    const [template, setTemplate] = useState('');
    const [clientId, setClientId] = useState('');
    const [startDate, setStartDate] = useState('');
    const [dueDate, setDueDate] = useState('');

    const today = new Date().toISOString().split("T")[0];

    const handleCreateWorkflow = async () => {
        const payload = {
            name: workflowName,
            description,
            status,
            category,
            template,
            account: { id: clientId },
            assignedTo: { id: userId },
            createdBy: { id: userId },
            startDate,
            dueDate
        };

        // console.log("Workflow create request payload:", payload);

        try {
            const response = await workflowApi.createWorkflow(payload, token);
            console.log("Workflow create response:", response);
            toast.success("Workflow created successfully!");
            setShowCreateWorkflow(false);
            onSuccess()
        } catch (error) {
            console.error("Error creating workflow:", error);
            toast.error(error);
        }
    };
useEffect(() => {
    if (accountId) {
        setClientId(accountId);
    }
}, [accountId]);

    return (
        <div className="fixed inset-0 bg-black -top-6 bg-opacity-50 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full p-3 max-h-[90vh] overflow-y-auto">
                <div className='flex flex-row items-center justify-between'>
                    <h3 className="text-lg font-semibold text-gray-900">Create New Workflows</h3>
                    <button onClick={() => setShowCreateWorkflow(false)} className='p-1 bg-red-50 hover:bg-red-100 text-red-800'><X/></button>
                </div>

                <div className="space-y-1">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-0">Workflow Name</label>
                            <input
                                type="text"
                                value={workflowName}
                                onChange={(e) => setWorkflowName(e.target.value)}
                                className="w-full px-3 py-1.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                placeholder="e.g., Monthly GST Compliance"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-0">Status</label>
                            <select
                                value={status}
                                onChange={(e) => setStatus(e.target.value)}
                                className="w-full px-3 py-1.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            >
                                <option value="">Select Status</option>
                                <option value="TODO">TODO</option>
                                <option value="IN_PROGRESS">In Progress</option>
                                <option value="COMPLETED">Completed</option>
                            </select>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-0">Client</label>
                            <select
                                value={clientId}
                                onChange={(e) => setClientId(e.target.value)}
                                disabled={!!accountId}
                                className="w-full px-3 py-1.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            >
                                <option value="">Select Client</option>
                                {clients.map(client => (
                                    <option key={client.id} value={client.id}>{client.name || client.accountName}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-0">Category</label>
                            <select
                                value={category}
                                onChange={(e) => setCategory(e.target.value)}
                                className="w-full px-3 py-1.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            >
                                <option value="">Select Category</option>
                                <option value="USER_DEFINED_TEMPLATE">User Defined</option>
                                <option value="GST_COMPLIANCE">GST Compliance</option>
                                <option value="TDS_MANAGEMENT">TDS Management</option>
                                <option value="AUDIT_AND_ASSURANCE">Audit & Assurance</option>
                                <option value="CLIENT_ONBOARDING">Client Onboarding</option>
                            </select>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-0">Template</label>
                            <select
                                value={template}
                                onChange={(e) => setTemplate(e.target.value)}
                                className="w-full px-3 py-1.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            >
                                <option value="">Select Template</option>
                                {workflowTemplates.map(t => (
                                    <option key={t.id} value={t.name}>{t.name}</option>
                                ))}
                            </select>
                        </div>

                        <div className="grid grid-cols-2 gap-2">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-0">Start Date</label>
                                <input
                                    type="date"
                                    min={today}
                                    value={startDate}
                                    onChange={(e) => {
                                        setStartDate(e.target.value);
                                        if (dueDate && e.target.value > dueDate) {
                                            setDueDate("");
                                        }
                                    }}
                                    className="w-full px-3 py-1.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-0">Due Date</label>
                                <input
                                    type="date"
                                    min={startDate || today}
                                    value={dueDate}
                                    onChange={(e) => setDueDate(e.target.value)}
                                    disabled={!startDate}
                                    className="w-full px-3 py-1.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                />
                            </div>
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-0">Description</label>
                        <textarea
                            rows={2}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            className="w-full px-3 py-1.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            placeholder="Describe the workflow purpose and scope..."
                        />
                    </div>

                </div>

                <div className="flex flex-row items-center justify-end space-x-3 mt-2">
                    {/* <Button label="Cancel" onClick={() => setShowCreateWorkflow(false)} /> */}
                    <button
                        type="button"
                        onClick={() => setShowCreateWorkflow(false)} 
                        className="bg-white py-2 px-4 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
                    >
                        Cancel
                    </button>
                    <Button label="Create Workflow" onClick={handleCreateWorkflow} />
                </div>
            </div>
        </div>
    );
};
